import { ReactElement, ReactNode } from 'react';
import { ResourceGroupDataItem, ResourceGroupProps } from '../../resource/ResourceGroup';
import { ResourceLoadRenderProps } from './ResourceLoader';

/* istanbul ignore next */
export const Resources = <DataList extends ResourceGroupDataItem[], Error, StateData>({ children }: Partial<ResourceGroupProps<DataList, Error, StateData>>) => children as ReactElement;
Resources.type = Symbol('ResourceLoader.Resources');

/* istanbul ignore next */
export const Content = <Data, >({ children }: {
  children?: ReactNode | ((values: ResourceLoadRenderProps<Data>) => ReactNode);
}) => children as ReactElement;
Content.type = Symbol('ResourceLoader.Content');
